<script setup>
import SettingsLayout from "@/Layouts/Settings.vue";
import Input from "@/Components/Settings/Input.vue";
import Textarea from "@/Components/Textarea.vue";
import Label from "@/Components/Settings/Label.vue";
import HeaderLink from "@/Components/Settings/HeaderLink.vue";
import Heading from "@/Components/Settings/Heading.vue";
import { Head, useForm } from "@inertiajs/inertia-vue3";
import { Inertia } from "@inertiajs/inertia";
import { ref } from "vue";

const props = defineProps({
    office: Object,
    workingHours: Object,
    errors: Object,
});

const canEdit = Inertia.page.props.auth.can["edit settings"];
const form = useForm({
    slip_title: props.office.slip_title ?? "",
    slip_text: props.office.slip_text ?? "",
});
const isSingle = ref(true);

function submitForm() {
    form.put("/appointmentSlip");
}
</script>

<template>
    <SettingsLayout>
        <Head title="Terminzettel - Grundeinstellungen" />

        <template #breadcrumb>Terminservice</template>
        <template #controls>
            <HeaderLink href="/" type="close" class="mr-3"
                >Schließen</HeaderLink
            >
            <HeaderLink v-if="canEdit" type="button" @click="submitForm()"
                >Speichern</HeaderLink
            >
        </template>

        <div class="flex flex-col h-full">
            <Heading title="Terminzettel" />

            <p class="max-w-2xl text-sm text-oteoText pb-8">
                Legen Sie hier den Standardtitle und -text fest, welcher auf
                Terminzetteln eingefügt werden soll. Logo und Kontaktdaten
                hinterlegen Sie bitte in den Stammdaten.
            </p>

            <div class="grow">
                <div class="flex h-full">
                    <div class="w-2/5 h-full pr-20 border-r border-gray-200">
                        <div class="">
                            <Label for="slip_title" value="Titel" />

                            <Input
                                id="slip_title"
                                type="text"
                                class="mt-1 block w-full"
                                v-model="form.slip_title"
                                required
                                placeholder="Terminservice"
                                :disabled="!canEdit"
                            />

                            <div
                                class="mt-2 text-red-600 text-sm"
                                v-if="errors.slip_title"
                            >
                                {{ errors.slip_title }}
                            </div>
                        </div>

                        <div class="mt-8">
                            <div class="row-span-3 flex flex-col h-40">
                                <Label for="slip_title" value="Text" />

                                <Textarea
                                    placeholder="Textfeld für Informationen für Ihre Patienten."
                                    class="w-full h-full resize-none"
                                    v-model="form.slip_text"
                                ></Textarea>

                                <div
                                    class="mt-2 text-red-600 text-sm"
                                    v-if="errors.slip_text"
                                >
                                    {{ errors.slip_text }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="flex flex-col w-1/2 h-full pl-20">
                        <div>
                            <span
                                class="mr-5 cursor-pointer"
                                :class="{ 'font-bold': isSingle }"
                                @click="isSingle = true"
                                >Vorschau Einzeltermin</span
                            >
                            <span
                                class="cursor-pointer"
                                :class="{ 'font-bold': !isSingle }"
                                @click="isSingle = false"
                                >Vorschau Terminserie</span
                            >
                        </div>

                        <div class="grow mt-3 mb-5">
                            <div
                                class="rounded shadow-[5px_5px_15px_5px_rgba(0,0,0,0.2)] h-full p-8"
                            >
                                <div class="flex flex-col h-full">
                                    <div class="flex mb-8">
                                        <div class="w-2/3 pr-5 flex flex-col">
                                            <h3 class="text-2xl">
                                                {{ form.slip_title }}
                                            </h3>

                                            <div class="mb-16 text-xs">
                                                <b>Max Mustermann</b>
                                            </div>

                                            <div
                                                v-if="isSingle"
                                                class="mb-5 text-xs"
                                            >
                                                <b>Fr. XX.XX.XXXX</b><br />
                                                <b>XX.XX Uhr</b><br />
                                                <span
                                                    >Dauer: ca. XX Minuten</span
                                                ><br />
                                                <span
                                                    >Behandlung: Lorem ipsum
                                                    dolor</span
                                                ><br />
                                                <span
                                                    >Behandler: Dr. Lorem
                                                    ipsum</span
                                                ><br />
                                            </div>

                                            <div v-else class="mb-8">
                                                <div class="mb-5 text-xs">
                                                    <b
                                                        >Fr. XX.XX.XXXX, XX.XX
                                                        Uhr</b
                                                    ><br />
                                                    <span
                                                        >Dauer: ca. XX
                                                        Minuten</span
                                                    ><br />
                                                    <span
                                                        >Behandlung: Lorem ipsum
                                                        dolor</span
                                                    ><br />
                                                    <span
                                                        >Behandler: Dr. Lorem
                                                        ipsum</span
                                                    ><br />
                                                </div>

                                                <div class="mb-5 text-xs">
                                                    <b
                                                        >Fr. XX.XX.XXXX, XX.XX
                                                        Uhr</b
                                                    ><br />
                                                    <span
                                                        >Dauer: ca. XX
                                                        Minuten</span
                                                    ><br />
                                                    <span
                                                        >Behandlung: Lorem ipsum
                                                        dolor</span
                                                    ><br />
                                                    <span
                                                        >Behandler: Dr. Lorem
                                                        ipsum</span
                                                    ><br />
                                                </div>

                                                <div class="mb-5 text-xs">
                                                    <b
                                                        >Fr. XX.XX.XXXX, XX.XX
                                                        Uhr</b
                                                    ><br />
                                                    <span
                                                        >Dauer: ca. XX
                                                        Minuten</span
                                                    ><br />
                                                    <span
                                                        >Behandlung: Lorem ipsum
                                                        dolor</span
                                                    ><br />
                                                    <span
                                                        >Behandler: Dr. Lorem
                                                        ipsum</span
                                                    ><br />
                                                </div>

                                                <div class="mb-5 text-xs">
                                                    <b
                                                        >Fr. XX.XX.XXXX, XX.XX
                                                        Uhr</b
                                                    ><br />
                                                    <span
                                                        >Dauer: ca. XX
                                                        Minuten</span
                                                    ><br />
                                                    <span
                                                        >Behandlung: Lorem ipsum
                                                        dolor</span
                                                    ><br />
                                                    <span
                                                        >Behandler: Dr. Lorem
                                                        ipsum</span
                                                    ><br />
                                                </div>

                                                <div class="mb-5 text-xs">
                                                    <b
                                                        >Fr. XX.XX.XXXX, XX.XX
                                                        Uhr</b
                                                    ><br />
                                                    <span
                                                        >Dauer: ca. XX
                                                        Minuten</span
                                                    ><br />
                                                    <span
                                                        >Behandlung: Lorem ipsum
                                                        dolor</span
                                                    ><br />
                                                    <span
                                                        >Behandler: Dr. Lorem
                                                        ipsum</span
                                                    ><br />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="w-1/3 text-xs">
                                            <div class="border-l pl-5 pb-8">
                                                <div
                                                    v-if="office.logo_thumb"
                                                    class="w-full pr-5 mb-4"
                                                >
                                                    <img
                                                        :src="office.logo_thumb"
                                                        alt="Logo"
                                                        width="100"
                                                    />
                                                </div>

                                                <div
                                                    class="leading-[0.7rem] text-xs mb-3"
                                                >
                                                    <div v-if="office.name">
                                                        <small>{{
                                                            office.name
                                                        }}</small>
                                                    </div>

                                                    <div v-if="office.street">
                                                        <small
                                                            >{{
                                                                office.street
                                                            }}
                                                            {{
                                                                office.street_nr
                                                            }}</small
                                                        >
                                                    </div>

                                                    <div
                                                        v-if="
                                                            office.postal_code &&
                                                            office.city
                                                        "
                                                    >
                                                        <small
                                                            >{{
                                                                office.postal_code
                                                            }}
                                                            {{
                                                                office.city
                                                            }}</small
                                                        >
                                                    </div>
                                                </div>

                                                <div
                                                    class="leading-[0.7rem] text-xs mb-3"
                                                >
                                                    <div
                                                        v-if="office.phone"
                                                        class="mb-1"
                                                    >
                                                        <small
                                                            >Tel.:{{
                                                                office.phone
                                                            }}</small
                                                        >
                                                    </div>

                                                    <div
                                                        v-if="office.email"
                                                        class="mb-1"
                                                    >
                                                        <small
                                                            >E-Mail:{{
                                                                office.email
                                                            }}</small
                                                        >
                                                    </div>

                                                    <div
                                                        v-if="office.website"
                                                        class="mb-1"
                                                    >
                                                        <small
                                                            >Web:{{
                                                                office.website
                                                            }}</small
                                                        >
                                                    </div>
                                                </div>

                                                <div
                                                    class="leading-[0.7rem] text-xs mb-3"
                                                >
                                                    <div class="mb-1"><small>Sprechzeiten:</small></div>
                                                    <table>
                                                        <template v-for="wh in workingHours">
                                                            <tr v-if="wh.open">
                                                                <td class="pr-2">
                                                                    <small
                                                                        >{{
                                                                            wh.weekday_short_formatted
                                                                        }}:</small
                                                                    >
                                                                </td>
                                                                <td>
                                                                    <small
                                                                        >{{
                                                                            wh.start.substr(0, wh.start.lastIndexOf(':'))
                                                                        }}-{{
                                                                            wh.end.substr(0, wh.end.lastIndexOf(':'))
                                                                        }} Uhr</small
                                                                    >
                                                                </td>
                                                            </tr>
                                                            <tr v-if="wh.hasBreak">
                                                                <td>
                                                                </td>
                                                                <td>
                                                                    <small
                                                                        >{{
                                                                            wh.start_2.substr(0, wh.start_2.lastIndexOf(':'))
                                                                        }}-{{
                                                                            wh.end_2.substr(0, wh.end_2.lastIndexOf(':'))
                                                                        }} Uhr</small
                                                                    >
                                                                </td>
                                                            </tr>
                                                        </template>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="mt-auto leading-[1rem] text-xs">
                                        {{ form.slip_text }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </SettingsLayout>
</template>
